import { render, staticRenderFns } from "./PendingPhotosCount.vue?vue&type=template&id=12cf0a12"
import script from "./PendingPhotosCount.vue?vue&type=script&lang=js"
export * from "./PendingPhotosCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports